import React from "react";
import styled from "styled-components";
import { ButtonClear, ButtonNext } from "./buttons";

const ControlsContainer = styled.div``;

const Controls = ({ handleClick, clear, disabled, item }) => (
	<ControlsContainer>
		<ButtonClear onClick={clear}>Redo</ButtonClear>
		<ButtonNext disabled={disabled} id={`button-${item}`} onClick={handleClick}>
			Next
		</ButtonNext>
	</ControlsContainer>
);

export default Controls;
